import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { User } from "src/_models/user";
import { roleTypeGroup, roleTypeOperator, roleTypeSap } from "src/_constants/roleType";

@Injectable({ providedIn: "root" })
export class UserService {
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  public ForOP = roleTypeOperator.includes(this.userInfo.role);
  public ForSAP = roleTypeSap.includes(this.userInfo.role);
  public httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("jwtToken"),
    }),
  };
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<User[]>(`${environment.apiUrl}/users`);
  }

  getRoleType = () => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/get-role`,
        null,
        this.httpOptions
      );
    }
  };

  viewFundStatementDetail = (oId, pId) => {
    if (this.ForSAP) {
      return this.http.post<any>(
        `${environment.apiUrl}/sapadmin/view-fund-statement`,
        {
          operatorId: oId,
          partnerId: pId,
        },
        this.httpOptions
      );
    }
  };

  getBalance = () => {
    if (this.userInfo.role == "OperatorAdmin") {
      return this.http.post<any>(
        `${environment.apiUrl}/opadmin/get-balance`,
        null,
        this.httpOptions
      );
    }
  };
}
